import React from "react";
import { Field, FieldInputProps, FieldMetaProps } from "formik";
import {
  Stack,
  Text,
  Columns,
  Column,
  TextField,
} from "@origin-digital/ods-core";
import { FormValues } from "../types";

interface IHomeUserLicencedPlumberProps {
  type: string;
}

const HomeUserLicencedPlumber = ({ type }: IHomeUserLicencedPlumberProps) => {
  return (
    <Stack space="large">
      <Text weight="medium">Licenced plumber</Text>
      <Columns
        collapseBelow="md"
        space={{ xs: "none", md: "xlarge" }}
        alignY="stretch"
      >
        <Column width="2/3">
          <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
            <Columns
              collapseBelow="sm"
              space={{
                xs: "xlarge",
                lg: "large",
              }}
            >
              <Column>
                <Field name={`${type}.homeUserLicencedPlumber.firstName`}>
                  {({
                    field,
                    meta,
                  }: {
                    field: FieldInputProps<string>;
                    meta: FieldMetaProps<FormValues>;
                  }) => (
                    <TextField
                      {...field}
                      id={field.name}
                      variant="outlined"
                      label="First name"
                      hideHelperTextSpace
                      error={!!meta.error}
                      helperText={meta.error}
                    />
                  )}
                </Field>
              </Column>
              <Column>
                <Field name={`${type}.homeUserLicencedPlumber.lastName`}>
                  {({
                    field,
                    meta,
                  }: {
                    field: FieldInputProps<string>;
                    meta: FieldMetaProps<FormValues>;
                  }) => (
                    <TextField
                      {...field}
                      id={field.name}
                      variant="outlined"
                      label="Last name"
                      hideHelperTextSpace
                      error={!!meta.error}
                      helperText={meta.error}
                    />
                  )}
                </Field>
              </Column>
            </Columns>
            <Field name={`${type}.homeUserLicencedPlumber.licenseNumber`}>
              {({
                field,
                meta,
              }: {
                field: FieldInputProps<string>;
                meta: FieldMetaProps<FormValues>;
              }) => (
                <TextField
                  {...field}
                  id={field.name}
                  variant="outlined"
                  label="Licence number"
                  hideHelperTextSpace
                  error={!!meta.error}
                  helperText={meta.error}
                />
              )}
            </Field>
            <Field name={`${type}.homeUserLicencedPlumber.phoneNumber`}>
              {({
                field,
                meta,
              }: {
                field: FieldInputProps<string>;
                meta: FieldMetaProps<FormValues>;
              }) => (
                <TextField
                  {...field}
                  id={field.name}
                  variant="outlined"
                  label="Phone"
                  hideHelperTextSpace
                  error={!!meta.error}
                  helperText={meta.error}
                />
              )}
            </Field>
            <Field name={`${type}.homeUserLicencedPlumber.email`}>
              {({
                field,
                meta,
              }: {
                field: FieldInputProps<string>;
                meta: FieldMetaProps<FormValues>;
              }) => (
                <TextField
                  {...field}
                  id={field.name}
                  variant="outlined"
                  label="Email"
                  hideHelperTextSpace
                  error={!!meta.error}
                  helperText={meta.error}
                />
              )}
            </Field>
          </Stack>
        </Column>
        <Column width="1/3" />
      </Columns>
    </Stack>
  );
};

export default HomeUserLicencedPlumber;
